var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    attrs: { label: "序号", width: "65", align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("span", {
              domProps: {
                textContent: _vm._s(
                  (_vm.pageIndex > 1 ? (_vm.pageIndex - 1) * _vm.pageSize : 0) +
                    scope.$index +
                    1
                ),
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }